import React, { useEffect, useRef } from 'react';
import { StoryPost } from '@/hooks/useDishStoryPosts';

const MAX_VIDEO_DURATION = 30;

interface StoryVideoSlideProps {
  post: StoryPost;
  isMuted: boolean;
  onNext: () => void;
  onPrev: () => void;
}

const StoryVideoSlide: React.FC<StoryVideoSlideProps> = ({ post, isMuted, onNext, onPrev }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoUrl = post.video_urls?.[0] ?? post.video_url ?? null;

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const timeout = setTimeout(() => {
      video.play().catch(() => {});
    }, 50);

    return () => {
      clearTimeout(timeout);
      video.pause();
    };
  }, [post.id]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.muted = isMuted;
  }, [isMuted]);

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (video && video.currentTime >= MAX_VIDEO_DURATION) {
      onNext();
    }
  };

  const handleLeftTap = (e: React.MouseEvent) => {
    e.stopPropagation();
    onPrev();
  };

  const handleRightTap = (e: React.MouseEvent) => {
    e.stopPropagation();
    onNext();
  };

  if (!videoUrl) return null;

  return (
    <div className="absolute inset-0 bg-black">
      <video
        ref={videoRef}
        src={videoUrl}
        playsInline
        muted={isMuted}
        loop={false}
        autoPlay
        onEnded={onNext}
        onTimeUpdate={handleTimeUpdate}
        className="absolute inset-0 w-full h-full object-contain"
      />

      {/* Left tap zone */}
      <div
        className="absolute left-0 top-0 w-1/3 h-full z-10 cursor-pointer"
        onClick={handleLeftTap}
      />

      {/* Right tap zone */}
      <div
        className="absolute right-0 top-0 w-1/3 h-full z-10 cursor-pointer"
        onClick={handleRightTap}
      />
    </div>
  );
};

export default StoryVideoSlide;
